import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from "../utils/firebase";

// A real default (not undefined) matters here: AuthProvider is only wired up
// in gatsby-browser.js's wrapRootElement, not gatsby-ssr.js, so useContext
// resolves to this default during `gatsby build`'s static HTML pass. Without
// one, destructuring `{ user, isLoading }` on the SSR pass would throw.
const AuthContext = createContext({ user: null, isLoading: true });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  // True until the first onAuthStateChanged callback fires, so a gated page
  // (e.g. /library) can render a loading state instead of briefly flashing
  // its signed-out view before the anonymous/real session resolves.
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async(user) => {
      setUser(user);
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider value={{ user, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
